/* match heights */

(function($) {
  $(document).ready(function() {
    $('.js-post-grid__item').matchHeight();
    $('.js-next-prev ').matchHeight();
  });
})(jQuery);
